import type { Fetcher } from "../fetcher";
import type { ClientFilters, CreateClientDto, UpdateClientDto } from "./types";
import type { Client } from "../entities/client";
import type { ApiSingleResponse, ApiCollectionResponse } from "../types/api";

export function createClientsRepository(fetcher: Fetcher) {
  return {
    async list(filters: ClientFilters = {}): Promise<{ items: Client[]; total: number }> {
      const params = new URLSearchParams();
      if (filters.page) params.append("page", String(filters.page));
      if (filters.limit) params.append("limit", String(filters.limit));
      if (filters.status) params.append("status", filters.status);
      if (filters.industry) params.append("industry", filters.industry);
      if (filters.search) params.append("search", filters.search);

      const query = params.toString();
      const url = query ? `/clients?${query}` : "/clients";

      const response = await fetcher<ApiCollectionResponse<Client>>(url);
      return {
        items: response.data?.items ?? [],
        total: response.data?.pagination?.total ?? 0,
      };
    },

    async get(id: string): Promise<Client> {
      const response = await fetcher<ApiSingleResponse<Client>>(`/clients/${id}`);
      return response.data;
    },

    async create(payload: CreateClientDto): Promise<Client> {
      const response = await fetcher<ApiSingleResponse<Client>>("/clients", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      return response.data;
    },

    async update(id: string, payload: UpdateClientDto): Promise<Client> {
      const response = await fetcher<ApiSingleResponse<Client>>(`/clients/${id}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
      });
      return response.data;
    },

    async delete(id: string): Promise<void> {
      await fetcher(`/clients/${id}`, { method: "DELETE" });
    },
  };
}
